import { Navigate, Outlet, useLocation } from "react-router-dom";

import { decodeToken } from "../../utils/functions";

const roleRedirects = {
  ADMIN: "/businesses",
  JEWELLERY_INSPECTOR: "/inspection-requests",
  JEWELLERY_BUYER: "/stocks-management",
  TAQABETH_ENFORCER: "/request-management",
};

const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("accessToken");

  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  let role = null;
  try {
    role = decodeToken(token)?.role;
    // eslint-disable-next-line no-unused-vars
  } catch (error) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!role) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.includes(role)) {
    return <Outlet />;
  }

  const redirectPath = roleRedirects[role] || "/not-found";
  return <Navigate to={redirectPath} replace />;
};

export default ProtectedRoute;
